export enum TrackingEventName {
  SignUpInitiated = 'Sign Up Initiated',
  SignUpCompleted = 'form_register',
  ProfileCompletion = 'Profile Completion',
  Login = 'Login',
  DepositInitiated = 'Deposit Initiated',
  WithdrawalRequested = 'Withdrawal Requested',
  GameStarted = 'Game Started',
  PromotionViewed = 'Promotion Viewed',
  PromotionClicked = 'Promotion Clicked',
  ButtonClick = 'Button Click',
  TimeSpentOnPage = 'Time Spent on Page',
}

export enum CriteriaWeights {
  Email = 0.1,
  OwnerBanks = 0.9,
}
